import { Layout } from 'antd';
import BreadcrumbComponent from '../../components/common/breadcrumb';
import AccessResourceForm from '../../components/views/api-management/index';

function AccessResourcePage() {
  const breadcrumbItems = ['Home', 'API Management'];
  return (
    <Layout className="content-page">
      <BreadcrumbComponent items={breadcrumbItems} />
      <AccessResourceForm />
    </Layout>
  );
}

export default AccessResourcePage;
